export const maximumStaticOverlaysPerArtwork = 8;
export function effectiveStaticOverlays(item) {
  if (item?.staticOverlays != null) {
    if (!Array.isArray(item.staticOverlays) || item.staticOverlays.length > maximumStaticOverlaysPerArtwork)
      throw overlayError("Each artwork supports up to 8 static overlay images.");
    return item.staticOverlays;
  }
  return item?.staticOverlay ? [item.staticOverlay] : [];
}
export function staticOverlayFields(item) {
  const overlays = effectiveStaticOverlays(item);
  return item?.staticOverlays != null
    ? { staticOverlays: structuredClone(overlays) }
    : overlays.length ? { staticOverlay: structuredClone(overlays[0]) } : {};
}
export function replaceStaticOverlays(item, overlays) {
  effectiveStaticOverlays({staticOverlays:overlays});
  item.staticOverlays = overlays;
  delete item.staticOverlay;
}
export function overlayError(message) {
  return Object.assign(new Error(message), {customerSafe:true});
}
